import { render, staticRenderFns } from "./CfhAnnounce.vue?vue&type=template&id=c54b49de&scoped=true&"
import script from "./CfhAnnounce.vue?vue&type=script&lang=js&"
export * from "./CfhAnnounce.vue?vue&type=script&lang=js&"
import style0 from "./CfhAnnounce.vue?vue&type=style&index=0&id=c54b49de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54b49de",
  null
  
)

export default component.exports